import * as React from 'react';
const SvgO = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M12 22C6.487 22 2 17.513 2 12S6.487 2 12 2s10 4.487 10 10-4.487 10-10 10Zm0-17.857A7.818 7.818 0 0 0 4.143 12 7.842 7.842 0 0 0 12 19.857c4.332 0 7.857-3.524 7.857-7.857S16.33 4.143 12 4.143Z", fill: "currentColor" })));
export default SvgO;
